"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveApi = exports.LiveApiFactory = exports.LiveApiFp = exports.LiveApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * LiveApi - axios parameter creator
 * @export
 */
const LiveApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: EnterToLiveRoom - Difficulty: 4 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kullanıcının canlı yayına katıldığının sunucuya bildirilmesini sağlar. (Dikkat: Bitmiş canlı yayınlara giriş kabul edilmemesi gerekiyor.) //TODO Bu komut aynı zamanda agora tokeni üretme işini yürütmelidir. Aynı zamanda komutu gönderen kullanıcının hesabının premium durumuna göre girişine onay verilecektir. Bu yüzden ek bilgi faydalı olacaktır.
         * @param {EnterCommand} [enterCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterToLiveRoom: (enterCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/live/enter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(enterCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetRoomInfo - Difficulty: 5 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Canlı yayına katılan kullanıcının ekranı üzerinde bulunan yayını kimin yaptığı, yayında chat\'in aktif mi pasif mi olduğu gibi bilgileri öğrenmesini ve bu bilgilere göre ekranı çizdirmesini sağlar. (Dikkat: Kullanıcının öncesinde bu odaya giriş yapmış olması gerekmektedir. Odaya daha önceden giriş yapmamış olması durumunda yetkisiz(403) http kodu döndürülmelidir. Yetki ve hesap kontrolleri Enter endpointinde yapılmaktadır)
         * @param {string} [roomId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomInfo: (roomId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/live/get_room_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (roomId !== undefined) {
                localVarQueryParameter['roomId'] = roomId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: LeaveFromLiveRoom - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayına katılmış kullanıcının, canlı yayından ayrıldığının sunucuya bildirilmesini sağlar. Bu komutun çalışabilmesi için kullanıcının halihazırda bir canlı yayını izliyor olması gerekiyor. (Dikkat: Canlı yayının bitmiş olması önemli değildir. Bitmiş canlı yayından yapılan çıkışlar da kaydedilmelidir)
         * @param {LeaveCommand} [leaveCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFromLiveRoom: (leaveCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/live/leave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leaveCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: Like - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayındaki kullanıcının yayını beğenmesini sağlar
         * @param {LikeCommand} [likeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        like: (likeCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/live/like`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(likeCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ToggleChat - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Canlı yayın sunucusunun chat\'i açmasını yada kapatmasını sağlar.
         * @param {ToggleChatCommand} [toggleChatCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChat: (toggleChatCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/live/toggle_chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(toggleChatCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.LiveApiAxiosParamCreator = LiveApiAxiosParamCreator;
/**
 * LiveApi - functional programming interface
 * @export
 */
const LiveApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.LiveApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: EnterToLiveRoom - Difficulty: 4 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kullanıcının canlı yayına katıldığının sunucuya bildirilmesini sağlar. (Dikkat: Bitmiş canlı yayınlara giriş kabul edilmemesi gerekiyor.) //TODO Bu komut aynı zamanda agora tokeni üretme işini yürütmelidir. Aynı zamanda komutu gönderen kullanıcının hesabının premium durumuna göre girişine onay verilecektir. Bu yüzden ek bilgi faydalı olacaktır.
         * @param {EnterCommand} [enterCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterToLiveRoom(enterCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enterToLiveRoom(enterCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetRoomInfo - Difficulty: 5 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Canlı yayına katılan kullanıcının ekranı üzerinde bulunan yayını kimin yaptığı, yayında chat\'in aktif mi pasif mi olduğu gibi bilgileri öğrenmesini ve bu bilgilere göre ekranı çizdirmesini sağlar. (Dikkat: Kullanıcının öncesinde bu odaya giriş yapmış olması gerekmektedir. Odaya daha önceden giriş yapmamış olması durumunda yetkisiz(403) http kodu döndürülmelidir. Yetki ve hesap kontrolleri Enter endpointinde yapılmaktadır)
         * @param {string} [roomId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomInfo(roomId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoomInfo(roomId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: LeaveFromLiveRoom - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayına katılmış kullanıcının, canlı yayından ayrıldığının sunucuya bildirilmesini sağlar. Bu komutun çalışabilmesi için kullanıcının halihazırda bir canlı yayını izliyor olması gerekiyor. (Dikkat: Canlı yayının bitmiş olması önemli değildir. Bitmiş canlı yayından yapılan çıkışlar da kaydedilmelidir)
         * @param {LeaveCommand} [leaveCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFromLiveRoom(leaveCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leaveFromLiveRoom(leaveCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: Like - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayındaki kullanıcının yayını beğenmesini sağlar
         * @param {LikeCommand} [likeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        like(likeCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.like(likeCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ToggleChat - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Canlı yayın sunucusunun chat\'i açmasını yada kapatmasını sağlar.
         * @param {ToggleChatCommand} [toggleChatCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChat(toggleChatCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleChat(toggleChatCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.LiveApiFp = LiveApiFp;
/**
 * LiveApi - factory interface
 * @export
 */
const LiveApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.LiveApiFp)(configuration);
    return {
        /**
         * Operation Id: EnterToLiveRoom - Difficulty: 4 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kullanıcının canlı yayına katıldığının sunucuya bildirilmesini sağlar. (Dikkat: Bitmiş canlı yayınlara giriş kabul edilmemesi gerekiyor.) //TODO Bu komut aynı zamanda agora tokeni üretme işini yürütmelidir. Aynı zamanda komutu gönderen kullanıcının hesabının premium durumuna göre girişine onay verilecektir. Bu yüzden ek bilgi faydalı olacaktır.
         * @param {EnterCommand} [enterCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterToLiveRoom(enterCommand, options) {
            return localVarFp.enterToLiveRoom(enterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetRoomInfo - Difficulty: 5 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Canlı yayına katılan kullanıcının ekranı üzerinde bulunan yayını kimin yaptığı, yayında chat\'in aktif mi pasif mi olduğu gibi bilgileri öğrenmesini ve bu bilgilere göre ekranı çizdirmesini sağlar. (Dikkat: Kullanıcının öncesinde bu odaya giriş yapmış olması gerekmektedir. Odaya daha önceden giriş yapmamış olması durumunda yetkisiz(403) http kodu döndürülmelidir. Yetki ve hesap kontrolleri Enter endpointinde yapılmaktadır)
         * @param {string} [roomId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomInfo(roomId, options) {
            return localVarFp.getRoomInfo(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: LeaveFromLiveRoom - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayına katılmış kullanıcının, canlı yayından ayrıldığının sunucuya bildirilmesini sağlar. Bu komutun çalışabilmesi için kullanıcının halihazırda bir canlı yayını izliyor olması gerekiyor. (Dikkat: Canlı yayının bitmiş olması önemli değildir. Bitmiş canlı yayından yapılan çıkışlar da kaydedilmelidir)
         * @param {LeaveCommand} [leaveCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFromLiveRoom(leaveCommand, options) {
            return localVarFp.leaveFromLiveRoom(leaveCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: Like - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayındaki kullanıcının yayını beğenmesini sağlar
         * @param {LikeCommand} [likeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        like(likeCommand, options) {
            return localVarFp.like(likeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ToggleChat - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Canlı yayın sunucusunun chat\'i açmasını yada kapatmasını sağlar.
         * @param {ToggleChatCommand} [toggleChatCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChat(toggleChatCommand, options) {
            return localVarFp.toggleChat(toggleChatCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LiveApiFactory = LiveApiFactory;
/**
 * LiveApi - object-oriented interface
 * @export
 * @class LiveApi
 * @extends {BaseAPI}
 */
class LiveApi extends base_1.BaseAPI {
    /**
     * Operation Id: EnterToLiveRoom - Difficulty: 4 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kullanıcının canlı yayına katıldığının sunucuya bildirilmesini sağlar. (Dikkat: Bitmiş canlı yayınlara giriş kabul edilmemesi gerekiyor.) //TODO Bu komut aynı zamanda agora tokeni üretme işini yürütmelidir. Aynı zamanda komutu gönderen kullanıcının hesabının premium durumuna göre girişine onay verilecektir. Bu yüzden ek bilgi faydalı olacaktır.
     * @param {EnterCommand} [enterCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    enterToLiveRoom(enterCommand, options) {
        return (0, exports.LiveApiFp)(this.configuration).enterToLiveRoom(enterCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetRoomInfo - Difficulty: 5 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Canlı yayına katılan kullanıcının ekranı üzerinde bulunan yayını kimin yaptığı, yayında chat\'in aktif mi pasif mi olduğu gibi bilgileri öğrenmesini ve bu bilgilere göre ekranı çizdirmesini sağlar. (Dikkat: Kullanıcının öncesinde bu odaya giriş yapmış olması gerekmektedir. Odaya daha önceden giriş yapmamış olması durumunda yetkisiz(403) http kodu döndürülmelidir. Yetki ve hesap kontrolleri Enter endpointinde yapılmaktadır)
     * @param {string} [roomId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    getRoomInfo(roomId, options) {
        return (0, exports.LiveApiFp)(this.configuration).getRoomInfo(roomId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: LeaveFromLiveRoom - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Canlı yayına katılmış kullanıcının, canlı yayından ayrıldığının sunucuya bildirilmesini sağlar. Bu komutun çalışabilmesi için kullanıcının halihazırda bir canlı yayını izliyor olması gerekiyor. (Dikkat: Canlı yayının bitmiş olması önemli değildir. Bitmiş canlı yayından yapılan çıkışlar da kaydedilmelidir)
     * @param {LeaveCommand} [leaveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    leaveFromLiveRoom(leaveCommand, options) {
        return (0, exports.LiveApiFp)(this.configuration).leaveFromLiveRoom(leaveCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: Like - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Canlı yayındaki kullanıcının yayını beğenmesini sağlar
     * @param {LikeCommand} [likeCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    like(likeCommand, options) {
        return (0, exports.LiveApiFp)(this.configuration).like(likeCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ToggleChat - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
     * @summary Canlı yayın sunucusunun chat\'i açmasını yada kapatmasını sağlar.
     * @param {ToggleChatCommand} [toggleChatCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    toggleChat(toggleChatCommand, options) {
        return (0, exports.LiveApiFp)(this.configuration).toggleChat(toggleChatCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LiveApi = LiveApi;
